import { Box, Stack, Typography } from '@mui/material';
import AtplPrimaryBt from '../../components/ATPlab/AtplPrimaryBtn/AtplPrimaryBt';
import { useNavigate, useLocation } from 'react-router-dom';
import AtplFooter from '../../components/ATPlab/atpFooter/AtplFooter';
import { useContext, useEffect, useState } from 'react';
import AuthContext from '../../context/AuthContext';
import AtplPrimaryBtnNew from '../../components/ATPlab/AtplPrimaryBtn/AtplPrimaryBtnNew';

export const AtplLanding = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const authContext = useContext( AuthContext );
	const [ isAuthenticated, setIsAuthenticated ] = useState( false );

	// The expected encoded key - hardcoded for consistency
	const EXPECTED_ENCODED_KEY = process.env.REACT_APP_ATP_ENCODED_KEY_FOR_URL;

	const handleStartPreScanAssessmentBtn = () => {
		localStorage.setItem( 'landing_url', '/atpllanding' );
		localStorage.setItem( 'atpl_authenticated', 'true' );
		// Navigate to demographics while preserving the authentication key
		navigate( `/atpl-demographics?key=${ EXPECTED_ENCODED_KEY }` );
	}

	useEffect( () => {
		// Clear local storage on component mount but preserve auth state
		const authStatus = localStorage.getItem( 'atpl_authenticated' );
		localStorage.clear();
		if ( authStatus ) {
			localStorage.setItem( 'atpl_authenticated', authStatus );
		}

		// Extract encoded client key from URL query params
		const params = new URLSearchParams( location.search );
		const encodedKey = params.get( 'key' );

		// Check if encoded key in URL matches our expected encoded key
		if ( encodedKey ) {
			const isValid = encodedKey === EXPECTED_ENCODED_KEY;
			setIsAuthenticated( isValid );

			// Store authentication status
			if ( isValid ) {
				localStorage.setItem( 'atpl_authenticated', 'true' );
			} else {
				console.error( 'Authentication failed: Invalid key' );
			}
		} else {
			setIsAuthenticated( false );
			console.error( 'Authentication failed: Missing key' );
		}
	}, [ location, EXPECTED_ENCODED_KEY ] );

	// If not authenticated, show error/redirect message
	if ( !isAuthenticated ) {
		return (
			<Box sx={ {
				width: '100%',
				height: '100vh',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				backgroundColor: 'white'
			} }>
				<Typography sx={ {
					fontSize: '20px',
					fontWeight: 500,
					textAlign: 'center',
					fontFamily: 'Poppins',
					padding: 3
				} }>
					Authorization required. Please use a valid authentication link to access this page.
				</Typography>
			</Box>
		);
	}

	return (
		<Box sx={ {
			width: '100%',
			height: {
				xs: "90vh", lg: "100vh", sm: "100vh", md: "100vh"
			},
			display: 'flex',
			justifyContent: 'center',
			backgroundColor: 'white',
			overflowX: 'hidden',
			overflowY: 'auto'
		} }>
			<Stack sx={ {
				width: {
					xs: '100%',
					sm: '390px',
					md: '100%'
				},
				maxWidth: {
					xs: '390px',
					sm: '390px',
					md: 'none'
				},
				height: '100%',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				position: 'relative',
				px: {
					xs: 6,
					sm: 4,
					md: 4
				}
			} }>
				<Stack sx={ {
					width: '100%',
					maxWidth: {
						md: '1200px'
					},
					mt: {
						xs: '100px',
						sm: '170px',
						md: '170px'
					},
					alignItems: 'center'
				} }>
					<Typography
						sx={ {
							fontSize: {
								xs: '28px',
								sm: '35px'
							},
							fontWeight: 700,
							lineHeight: {
								xs: '30px',
								sm: '35px'
							},
							textAlign: 'center',
							fontFamily: 'Poppins'
						} }
					>
						Your health is worth our time.
					</Typography>

					<Stack sx={ {
						width: '100%',
						maxWidth: '390px',
						alignItems: 'center',
						spacing: 2,
						mt: 3
					} }>
						<Typography sx={ {
							pt: {
								xs: 2,
								sm: '27px'
							},
							textAlign: 'center',
							fontWeight: 400,
							fontSize: '15px',
							lineHeight: '20px',
							fontFamily: 'Poppins',
							mb: 2
						} }>
							Take our assessment and harness
							cutting edge AI to recommend the
							perfect wellness routine for you.
						</Typography>

						<Typography sx={ {
							textAlign: 'center',
							fontWeight: 400,
							fontSize: '15px',
							lineHeight: '20px',
							fontFamily: 'Poppins',
							mb: 3
						} }>
							It takes 2-3 minutes.
						</Typography>

						<AtplPrimaryBtnNew
							text="Take the Assessment"
							onClick={ handleStartPreScanAssessmentBtn }
							sx={ {
								marginTop: {
									xs: '15px',
									sm: '15px',
									md: '16px',
									lg: '20px'
								},
							} }
						/>
					</Stack>
				</Stack>

				<Stack sx={ {
					position: 'absolute',
					bottom: {
						xs: '20px',
						sm: '20px'
					},
					left: '50%',
					transform: 'translateX(-50%)',
					width: {
						xs: '90%',
						sm: 'auto'
					}
				} }>
					<AtplFooter footerTitle="This health assessment is powered by" />
				</Stack>
			</Stack>
		</Box>
	)
}